import { create } from "zustand";

export const useCompanyStore = create((set) => ({
  Company: undefined,
  Application: undefined,
  SelectedCompany: undefined,
  setCompany: (state) =>
    set({
      Company: state,
    }),
  setApplication: (state) =>
    set({
      Application: Application,
    }),
  setSelectedCompany: (state) =>
    set({
      SelectedCompany: state,
    }),
}));
